///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.summary = abcsetup.rfq.bid_requests.summary || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.summary = {
    init: function () {
        abcsetup.setTitle('RFQ Bids Summary');

        this._initDatatables();
        this._setupBidsAttachmentsToggle()
        this._setupNotParticipatingToggle()

        // Init the RFQ comments lib confirmation lib.
        abcsetup.rfq.comments.init();
    },

    _initDatatables() {
        abcsetup.datatables.client_side.init($('#bid-summary-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": -1,
            "order": [[1, "asc"]],
            "columnDefs": [{
                "targets": 5,
                "orderable": false
            }],
        });

        abcsetup.datatables.client_side.init($('#supplier-attachments-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "order": [[0, "asc"]],
            "columnDefs": [{
                "targets": 2,
                "orderable": false
            }],
        });

        // Init bid refused datatable
        abcsetup.datatables.client_side.init($('#non-bid-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[1, "asc"]],
        });

        // Init no-response datatable
        abcsetup.datatables.client_side.init($('#no-response-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[0, "asc"]],
        });
    },

    _setupNotParticipatingToggle() {
        $('#no-response-table').hide();
        $(document).on('change', '[name=not_participating_toggle]', function () {
            $('#not-participating-toggle .btn').removeClass('active');

            if ($(this).val() === 'no_response') {
                $('#non-bid-table').hide();
                $('#no-response-table').show();
            } else {
                $('#non-bid-table').show();
                $('#no-response-table').hide();
            }
        });
    },

    _setupBidsAttachmentsToggle() {
        $('#supplier-attachments-table').hide();
        $(document).on('change', '[name=bids_toggle]', function () {
            $('#bids-toggle .btn').removeClass('active');

            if ($(this).val() === 'supplier_attachments') {
                $('#bid-summary-table').hide();
                $('#supplier-attachments-table').show();
            } else {
                $('#bid-summary-table').show();
                $('#supplier-attachments-table').hide();
            }
        });
    },
}
